<template>
<div>
    <div class="form-group">
    <label  for="categoria"><strong>MISURA</strong></label>
        <select @change="$emit('update',sizeId,$event)" :disabled="!props.isActive" :required="props.required"  class="form-control" v-model="sizeId">
        <option v-if="props.optionBase" value="0"> -- TUTTE LE MISURE -- </option>    
        <option v-for="(option,index) in items" :key="index" :value="option.sizeId">
            {{ option.size  }}
        </option>
        
        </select> 
    </div>
</div>

</template>
<script>
import api             from "@/api";
import {mapGetters }   from 'vuex';

export default {
  props:['props'],
  
  data() {
    return {

      sizeId                 : 0,
      items                  : [],
      spinner                : false,
      
           
    };
  },
  computed:
  {
      ...mapGetters(['company']) 
  },   
 
  created: function() 
  {
      this.getData()
  },
  methods: 
  { 
      

    async getData()
    {            
      

      let sp    = {'sp'        : 'spCompanySizeList'}
      let data  = {'companyId' : this.company.Id}
      let json  = Object.assign(data, sp);  

      await api.post(json).then(res => {
            if(res.status==200)
            {
                //console.log(res.data.recordsets[0])
                this.items       = res.data.recordsets[0]
                
            }
           else if(res.status==500)
           {
                console.log(res.data)

            } 
          else
            {
                console.log('Network Error.')                  
                 
            } 
      
      

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

    

    },
  
    
    
  
}

}
</script>
<style scoped>

</style>